import { render, staticRenderFns } from "./LinksUnifit.vue?vue&type=template&id=b7640c50&scoped=true"
import script from "./LinksUnifit.vue?vue&type=script&lang=js"
export * from "./LinksUnifit.vue?vue&type=script&lang=js"
import style0 from "./LinksUnifit.vue?vue&type=style&index=0&id=b7640c50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7640c50",
  null
  
)

export default component.exports